import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Home = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div style={styles.container}>
      <div style={styles.hero}>
        <h1 style={styles.title}>Sytch</h1>
        <p style={styles.subtitle}>
          Safe, affordable ride sharing between real people already headed your way.
        </p>
        <div style={styles.buttons}>
          <button
            style={styles.primaryBtn}
            onClick={() => navigate('/search')}
          >
            Find a Ride
          </button>
          {user ? (
            <button
              style={styles.secondaryBtn}
              onClick={() => navigate('/post-trip')}
            >
              Offer a Ride
            </button>
          ) : (
            <button
              style={styles.secondaryBtn}
              onClick={() => navigate('/register')}
            >
              Join Sytch
            </button>
          )}
        </div>
      </div>

      <div style={styles.features}>
        <div style={styles.feature}>
          <h3>✓ Verified Users</h3>
          <p>Every member passes a background check before joining.</p>
        </div>
        <div style={styles.feature}>
          <h3>★ Trusted Reviews</h3>
          <p>Real ratings from real trips help you choose confidently.</p>
        </div>
        <div style={styles.feature}>
          <h3>$ You Set the Price</h3>
          <p>Negotiate directly. Rides can even be free.</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '20px',
  },
  hero: {
    textAlign: 'center',
    padding: '80px 20px',
    background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
    borderRadius: '16px',
    color: 'white',
    marginBottom: '40px',
  },
  title: {
    fontSize: '64px',
    fontWeight: 'bold',
    margin: '0 0 16px 0',
    color: '#4fc3f7',
  },
  subtitle: {
    fontSize: '20px',
    color: '#b0bec5',
    maxWidth: '500px',
    margin: '0 auto 40px auto',
    lineHeight: '1.6',
  },
  buttons: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  primaryBtn: {
    padding: '16px 40px',
    fontSize: '18px',
    background: '#4fc3f7',
    color: '#1a1a2e',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  secondaryBtn: {
    padding: '16px 40px',
    fontSize: '18px',
    background: 'transparent',
    color: 'white',
    border: '2px solid white',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold',
  },
  features: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px',
    marginBottom: '40px',
  },
  feature: {
    padding: '32px',
    background: '#f5f5f5',
    borderRadius: '12px',
    textAlign: 'center',
  },
};

export default Home;